<div class="row" style="padding: 15px;">
  <div class="data-not-found" *ngIf="!isDataAvailable">
    No Payment Code Details Available
  </div>
  <div>
    <p-table *ngIf="isDataAvailable" 
      [columns]="columns" 
      [value]="paymentClassification" 
      [paginator]="true"
      [first]="pageNumber" 
      [rows]="rows" 
      [totalRecords]="totalRecords" 
      [(selection)]="selectedPaymentCodeClassification"
      [sortField]="sortField" 
      [sortOrder]="sortOrder" 
      [reorderableColumns]="true" 
      sortMode="multiple"
      [loading]="isTableLoading" 
      [loadingIcon]="''" 
      [resizableColumns]="true" 
      columnResizeMode="expand"
      derableColumns="true" 
      [editable]="true" 
      (onPage)="onPageChange($event)" 
      [dataKey]="'id'"
    >
      <ng-template pTemplate="paginatorright">
        <div class="p-text-right">
          <label for="perPage" class="p-mr-2">Rows per page:</label>
          <select id="perPage" class="p-inputtext" (change)="onRowsChange($event )">
            <option *ngFor="let option of rowsOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="text-align: center !important;" scope="col"><button mat-icon-button color="primary" (click)="addNewRow()" [disabled]="isAnyRowBeingEdited"><mat-icon>add</mat-icon></button></th>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col">
            <div class="top-div">
              <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
              <div class="spacer"><p-sortIcon [field]="col.field" /></div>
              <div>
                <p-columnFilter class="icon-section" [ngClass]="{'active': col.advancefilter.isAdvanceFilterUsed}"
                  #filterRef [type]="col.type" [field]="col.field" display="menu" [showMatchModes]="false"
                  [showOperator]="false" [filterModel]="col.advancefilter">
                  <ng-template pTemplate="filter" let-values let-filter="filterCallback" let-index="index">
                    <div class="rules-holder" *ngFor="let constraint of col.advancefilter!.constraints; let i = index">
                      <p *ngIf="i === 0">Show items with value that:</p>
                      <p-dropdown class="p-dropdown" [options]="col.advancefilter!.matchModeOptions"
                        [(ngModel)]="constraint.matchMode" optionLabel="label" optionValue="value"
                        (change)="onMatchModeChange($event, col.field, i)" />

                      <input *ngIf="col.type == 'string' || col.type == 'number'" type="text" pInputText
                        class="p-inputtext" [value]="constraint.value" (input)="onRuleChange($event, col.field, i)" />

                      <p-calendar class="p-calendar" *ngIf="col.type == 'date'" [(ngModel)]="constraint.value"
                        [showTime]="true" [hourFormat]="'12'" [showIcon]="true" [placeholder]="'Select date and time'"
                        (onSelect)="onDateRuleChange($event, col.field, i)"></p-calendar>

                      <div class="operator" *ngIf="i === 0">
                        <p-dropdown [options]="[
                              { label: 'And', value: 'and' },
                              { label: 'Or', value: 'or' }
                            ]" [(ngModel)]="col.advancefilter.operator"
                          (onChange)="onOperatorChange($event, col.field)" class="p-dropdown">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="p-d-flex p-jc-end p-ai-center p-gap-2">
                      <button pButton type="button" label="Apply" class="p-button-primary p-button-sm"
                        (click)="applyCall(col, filterRef)">
                      </button>
                      <button pButton type="button" label="Clear" class="p-button-secondary p-button-sm"
                        (click)="clearCall(col, filter, filterRef)">
                      </button>
                    </div>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
            <div class="bottom-div">
              <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false" (onClear)="customClear(col)">
                <ng-template pTemplate="filter">
                  <p-multiSelect [options]="col.filterOptions" placeholder="Select" [(ngModel)]="filters[col.field]"
                    [optionLabel]="'label'" appendTo="body" (onChange)="customFilter(col.type)"
                    [panelStyle]="{'z-index': '1000'}">
                    <ng-template let-option pTemplate="item">
                      <div class="inline-block vertical-align-middle">
                        <span class="ml-1 mt-1">{{ option['label'] }}</span>
                      </div>
                    </ng-template>
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
              <button class="clear-button" mat-icon-button
                *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" (click)="customClear(col)">
                <mat-icon class="clear-button-icon">close</mat-icon>
              </button>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-i="rowIndex">
        <tr [pSelectableRow]="rowData" [class.selected-row]="selected" [ngClass]="{ 'p-highlight': isSelected( i) }"
          (click)="onRowClick($event, i)" (keydown)="onRowKeydown($event, i)" (focus)="onRowFocus($event, i)" (mousedown)="onMouseDown($event, i)" (mouseover)="onMouseOver($event, i)"
          (mouseup)="onMouseUp()">
          <td style="text-align: center !important">
            <ng-container *ngIf="isDeleteMode; else editControls">
              <div (mousedown)="$event.stopPropagation()">
                <p-tableCheckbox [value]="rowData" [checked]="selectedIndexes.includes(i)"
                  (click)="onCheckboxClick(i)" (keydown)="onCheckboxClick(i)"></p-tableCheckbox>
              </div>
            </ng-container>
            <ng-template #editControls>
              <ng-container *ngIf="editingPaymentInfoRows[i]; else showEditBtn">
                <button mat-icon-button color="primary" (click)="saveRow(i)"><mat-icon>save</mat-icon></button>
                <button mat-icon-button color="warn" (click)="cancelSave(i)"><mat-icon>cancel</mat-icon></button>
              </ng-container>
              <ng-template #showEditBtn>
                <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="editRow(i)"
                  [disabled]="isAnyRowBeingEdited"><mat-icon>edit</mat-icon></button>
                <button *ngIf="!rowData[i]?.isNew" mat-icon-button color="accent" (click)="deleteRow( i )"
                  [disabled]="isAnyRowBeingEdited"><mat-icon>delete</mat-icon></button>
              </ng-template>
            </ng-template>
          </td>
          <td *ngFor="let col of columns">
            <ng-container>
              <ng-container *ngIf="editingPaymentInfoRows[i]; else readOnlyCell">
                <ng-container [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'number'">
                    <input type="number" pInputText [placeholder]="'Enter ' + col.title"
                      [(ngModel)]="rowData[col.field]" #fieldRef="ngModel" [disabled]="col.disabled" required
                      (mousedown)="$event.stopPropagation()" />
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                  </ng-container>
                  
                  <!-- Vendor ERP ID Autocomplete -->
                  <ng-container *ngSwitchCase="'autoComplete'">
                    <p-autoComplete
                      [(ngModel)]="rowData[col.field]"
                      [suggestions]="filteredVendors"
                      (completeMethod)="searchVendors($event, col.field)"
                      (onSelect)="onVendorSelect($event, rowData, i)"
                      (ngModelChange)="onVendorInputChange($event, i)"
                      field="vendorERPID"
                      [minLength]="2"
                      [dropdown]="true"
                      [required]="col.required"
                      [placeholder]="'Enter ' + col.title"
                      appendTo="body"
                      (mousedown)="$event.stopPropagation()"
                      #fieldRef="ngModel"
                      [disabled]="!isNewRowBeingEdited && col.disabled"
                    >
                      <ng-template let-item pTemplate="item">
                        <div>{{ item.vendorERPID.trim() }} - {{ item.vendorname.trim() }}</div>
                      </ng-template>
                    </p-autoComplete>
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                    <div *ngIf="rowData[col.field] && rowData[col.field] !== clonedRows[i]?.vendorERPID && !selectedVendors[i] && (fieldRef.dirty || validationTouched[i])" class="p-error">
                      <span style="white-space: normal;">Please select a valid Vendor ERP Id from the list.</span>
                    </div>
                  </ng-container>

                  <!-- Company Code Dropdown -->
                  <ng-container *ngSwitchCase="'companyCodeDropdown'">
                    <p-dropdown
                      [(ngModel)]="rowData[col.field]"
                      [options]="companyCodeValues"
                      optionLabel="companycode"
                      optionValue="companycode"
                      [placeholder]="'Select ' + col.title"
                      [required]="col.required"
                      appendTo="body"
                      #companyCodeRef="ngModel"
                      [disabled]="!isNewRowBeingEdited && col.disabled"
                    ></p-dropdown>
                    <div *ngIf="companyCodeRef.invalid && (companyCodeRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="companyCodeRef.errors?.['required']">{{ col.title }} is required.</span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <input style="width: -webkit-fill-available;" [required]="col.required"
                      [placeholder]="'Enter ' + col.title" [(ngModel)]="rowData[col.field]" pInputText
                      [required]="col.required" [disabled]="(col.field === 'system' || col.field === 'name') || (!isNewRowBeingEdited && col.disabled)" #fieldRef="ngModel"
                      (mousedown)="$event.stopPropagation()" />
                    <div *ngIf="fieldRef.invalid && (fieldRef.touched|| validationTouched[i])" class="p-error">
                      <span style="white-space: normal;" *ngIf="fieldRef.errors?.['required']">{{ col.title }} is
                        required.</span>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #readOnlyCell>
                <ng-container>
                  {{ rowData[col.field] }}
                </ng-container>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>